export default "__VITE_ASSET__DBmEOX2o__"